import { ApiError } from 'src/types/interfaces/api-error';

export const getInviteEmployeeErrorTranslation = (error: ApiError) => {
  if (!error.response.data.message) {
    return 'common:errorMessages.somethingWentWrong';
  }

  if (error.response.status === 409) {
    return 'employees:employees.inviteEmployeeDialog.errors.employeeAlreadyExists';
  }

  return error.response.data.message;
};
